import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useEffect, useState } from "react";
import Modal from "../../components/modal";
import readXlsxFile from "read-excel-file";
import { arraysEqual } from "helpers/arrayEqual";
import { bulkUpdateAccountsCall } from "api/api";

const updateAccountExcelFields = [
  "account_number",
  "holder_name",
  "address",
  "phone_number",
  "membership_date",
  "remarks",
  "free_units",
  "current_balance",
  "initial_reading",
  "status",
  "initial_reading_date",
  "transferred_to",
  "transferred_date"
];

export default function AccountPopup({ open, setOpen, organization }) {
  useEffect(() => {
    if (open) {
      setFile(null);
    }
  }, [open]);

  const [file, setFile] = useState(null);

  if (!organization) {
    return null;
  }

  const onFileSelect = async (file) => {
    const [headers, ...rows] = await readXlsxFile(file);
    if (arraysEqual(headers, updateAccountExcelFields)) {
      setFile(file);
    } else {
      setFile(null);
      global.showAlert(
        "Validation Errors",
        `Uploaded excel file is not compatible. it should contains these fields ${updateAccountExcelFields}`,
        "warning"
      );
    }
  };

  const onUpload = async () => {
    const [headers, ...rows] = await readXlsxFile(file);
    const fileResponse = await bulkUpdateAccountsCall({
      headers,
      rows,
      organization_id: organization.id,
    });
    if (fileResponse) {
      global.showAlert("Success", `Accounts saved successfully`, "success");
      setOpen(false);
    }
  };

  return (
    <Modal
      title={"Update Accounts"}
      open={open && !!organization}
      actions={
        <MDBox display="flex" gap={1} justifyContent="right">
          <MDButton onClick={onUpload} variant="gradient" color="info" disabled={!file}>
            upload
          </MDButton>
          <MDButton
            onClick={() => {
              setOpen(false);
            }}
            variant="gradient"
            color="error"
          >
            cancel
          </MDButton>
        </MDBox>
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 10,
        }}
      >
        <MDTypography>{organization.name}</MDTypography>
        <input
          accept=".xlsx"
          type="file"
          onChange={async (e) => {
            if (e.target?.files?.[0]) {
              onFileSelect(e.target.files[0]);
            } else {
              setFile(null);
            }
          }}
        />
      </div>
    </Modal>
  );
}
